// TotalInventoryExpired Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get totalInventoryExpiredList from backend then update totalInventoryExpiredList in vuex store ***** //
export const updateTotalInventoryExpiredList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('outlet_expired', { params: params })
    commit('updateTotalInventoryExpiredList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch TotalInventoryExpired from backend ***** //
export const fetchTotalInventoryExpiredCount = async ({ commit }) => {
  try {
    const result = await Axios.get('outlet_expired_count')
    commit('fetchTotalInventoryExpiredCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get reportInventoryExpiredList from backend then update reportInventoryExpiredList in vuex store ***** //
export const updateReportInventoryExpiredList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_expired/${payload.outlet_id}`, {
      params: params
    })
    commit('updateTotalInventoryExpiredList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch reportInventoryExpired from backend ***** //
export const fetchReportInventoryExpiredCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_expired_count/${payload}`)
    commit('fetchTotalInventoryExpiredCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

export const moveExpiredToDamagedProduct = async (ignored, payload) => {
  try {
    await Axios.post('move_expired_to_damaged', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Moved Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
